export default __webpack_public_path__ + "static/media/S (21).8bd03fdd.png";